import React from 'react';
import PropTypes from 'prop-types';
import AddressSearch from './AddressSearch.jsx';
import styles from './SearchHeader.less';
import featureSwitchReader from '../../utils/featureSwitchReader';
import { HP_HERO_MAP, HP_HERO_PHOTO } from '../../utils/featureFlags';

export const SearchHeader = ({ isFeatureOn }) => {
  const getBackgroundType = () => {
    if (isFeatureOn(HP_HERO_MAP)) {
      return 'map';
    }
    if (isFeatureOn(HP_HERO_PHOTO)) {
      return 'photo';
    }
    return 'original';
  };
  const backgroundType = getBackgroundType();

  return (
    <div className={`${styles.searchHeader}`}>
      <div
        data-imageversion="0.0.2"
        data-backgroundtype={backgroundType}
        className={styles.buildingsWithListingsBackground}
      />
      <div className={styles.searchWrapper}>
        <AddressSearch />
      </div>
    </div>
  );
};

SearchHeader.propTypes = {
  isFeatureOn: PropTypes.func,
};

SearchHeader.defaultProps = {
  isFeatureOn: featureSwitchReader.getInstance().isFeatureOn,
};

export default SearchHeader;
